import API_URL from '../apiconfig';
import axios from './api';
import {
  BookingSiteSettings,
  UpdateBookingSitePayload,
} from '../types/bookingSite';

export async function getBookingSite(businessId: string) {
  try {
    const response = await axios.get(
      `${API_URL}/v1/booking-site/${businessId}`,
    );
    return response?.data?.result as BookingSiteSettings;
  } catch (error) {
    throw new Error('Cannot get booking site settings', { cause: error });
  }
}

export async function updateBookingSite(
  businessId: string,
  payload: UpdateBookingSitePayload,
) {
  // Uncaught on purpose: the API names the field it refused, and the settings
  // page marks that input rather than showing one message for all of them.
  const response = await axios.patch(
    `${API_URL}/v1/booking-site/${businessId}`,
    payload,
  );
  return response?.data?.result as BookingSiteSettings;
}
